import React from 'react';
import classNames from 'classnames';

import styles from './styled-button.scss';
import { handleEnterKeyUp } from '../../services/accessibility';

interface ButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  secondary?: boolean;
  dataHook?: string;
  disabled?: boolean;
  blank?: boolean;
  autofocus?: boolean;
  wired?: boolean;
}

export class StyledButton extends React.Component<ButtonProps> {
  buttonRef: HTMLButtonElement | null = null;

  componentDidMount() {
    if (this.props.autofocus) {
      setTimeout(() => this.buttonRef && this.buttonRef.focus(), 1000);
    }
  }

  setButtonRef = (ref: HTMLButtonElement) => (this.buttonRef = ref);

  getContainerClass() {
    const { className, secondary, disabled, blank, wired = true } = this.props;
    return classNames([
      styles.button,
      className,
      {
        'ma-primary-button': !secondary && !blank && wired,
        'ma-secondary-button': secondary && wired,
        [styles.primaryButton]: !secondary && !wired,
        [styles.secondaryButton]: secondary && !wired,
        [styles.disabled]: disabled,
      },
    ]);
  }

  render() {
    const { children, onClick, dataHook } = this.props;
    return (
      <button
        ref={this.setButtonRef}
        className={this.getContainerClass()}
        onClick={onClick}
        onKeyUp={handleEnterKeyUp(onClick)}
        data-hook={dataHook || null}
      >
        <span className={styles.wrapper}>{children}</span>
      </button>
    );
  }
}

export default StyledButton;
